export enum DP_STOCK_TYPE {
    IN_STOCK = 'INSTOCK',
    REPLENISHMENT_DATE = 'REPLENISHMENTDATE',
    DATE_CONFIRMATION = 'DELIVERYDATECONFIRMATION',
    OBSOLETE = 'OBSOLETE',
    COMING_SOON = 'COMINGSOON'
}
